import { createContext } from '@lit/context'
import type { AepCheckResponse } from '../services/aep.service'
import type { QuoteResponse } from '../services/quote-service'

export interface FormDataPersist {
  dentalSelected: boolean
  visionSelected: boolean
  showSpouseCard: boolean
  dependentCards: number[]
  primaryDob: string
  startDate: string
  spouseData: { dob: string; dentalChecked: boolean; visionChecked: boolean }
  dependentsData: Array<{
    id: number
    dob: string
    dentalChecked: boolean
    visionChecked: boolean
  }>
  // Agent-only persisted fields
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  deliveryMethod?: 'e' | 'p' | ''
  enrollmentFor?: string
}

export interface ShopperContextType {
  aepCheckData: AepCheckResponse | null
  quoteData: QuoteResponse | null
  isAgent: boolean
  formData?: FormDataPersist
  // Agent session details for banner and quote enrichment
  producerSession?: Record<string, any> | null
}

export const shopperContext = createContext<ShopperContextType>('shopper')
